export default __webpack_public_path__ + "static/media/404.a9ef9b5e.png";